module.exports = __webpack_public_path__ + "img/The Daruma Challenge main capsule_alt.d85bacee.png";